import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { StorageService } from '../../services/storage.service';
import { UserRegisterDataDTO } from '../../classes/user-account.dto';

@Component({
  selector: 'app-assistance-service',
  imports: [TranslateModule, NzIconModule, NzGridModule, NzDividerModule],
  templateUrl: './assistance-service.component.html',
  styleUrls: ['./assistance-service.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AssistanceServiceComponent {
  user: UserRegisterDataDTO;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private storage: StorageService
  ) {
    this.user = JSON.parse(storage.getItem('userData')!);
  }

  protected genericButton(): void {
    this.router.navigate(['general'], { relativeTo: this.route });
  }

  protected covidButton(): void {
    this.router.navigate(['covid'], { relativeTo: this.route });
  }
}
